import React, { useState, useEffect } from "react";
import { getData } from "app/data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as LeftSide } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightSide } from "images/background/right-box-graphic.svg";
import { ReactComponent as BlueRectangle } from "images/background/software-solution-graphic-blue.svg";
import { ReactComponent as RedRectangle } from "images/background/software-solution-graphic-red.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const MerchantService = () => {
  const posData = getData("posDeviceData");

  return (
    <section className="merchantService">
      {/* <div className="hg-bg-left">
        <LeftSide className="hg-bg-left" />
      </div> */}

      {/* <RightSide className="hg-bg-right" /> */}
      <div className="container">
        <div className="header">
          <h2 className="mb-5">
            <FormattedMessage id={"merchant_service"} />
          </h2>
          <div className="d-flex flex-column flex-md-row  justify-content-center align-items-center p-2">
            <Link
              to="/merchant-service"
              className="blue"
            >
              <FormattedMessage id={"browse_pos_devices"} />
            </Link>

            <Link
              to="/browse-by-use-cases"
              className="red"
            >
              <FormattedMessage id={"browse_by_use_cases"} />
            </Link>
            <Link
              to="/service-rate"
              className="blue"
            >
              <FormattedMessage id={"service_rate"} />
            </Link>
          </div>
            {/* modified code */}
            <h3 className="mt-5 me-5 ms-5">
              <FormattedMessage id={"merchant_service_introduction"} />
            </h3>
        </div>


        {posData.length > 0 ? (
          posData.map(item => {
            return (
              <div
                className={item.id % 2 !== 0 ? "row" : "row flex-row-reverse"}
              >
                <div
                  className={`col-lg-6 col-sm-12 ${item.class ? item.class : null
                    }`}
                >
                  <div className="text-wrapper">
                    <div className="title">
                      {item.id % 2 !== 0 ? <BlueRectangle /> : <RedRectangle />}
                      <h2>{item.title}</h2>
                    </div>

                    <p key={item.id}>{item.text}</p>
                    <div className="btn-wrapper">
                      <Link
                        className={
                          item.id % 2 !== 0 ? "green-button" : "accent-button"
                        }
                        to={item.link}
                      >
                        <FormattedMessage id={"learn_more"} />
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className={`col-lg-6 col-sm-12 ${item.class ? item.class : null
                    }`}
                >
                  <div className="image-wrapper">
                    <img src={item.img} alt="MerchantService" />
                  </div>
                </div>
              </div>
            );
          })
        ) : null}


      </div>

    </section >
  );
};

export default MerchantService;